import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsNumber, IsOptional, Max, Min, ValidateNested } from 'class-validator';
import { StoreExposeGroup } from '../interface';
import { ReadAbstractStoreDelayedOrdersDto } from './ReadAbstractStoreDelayedOrdersDto';
import { ReadAbstractStoreScheduleDto } from './ReadAbstractStoreScheduleDto';
import { ReadStoreDeliveryAreaDto } from './ReadStoreDeliveryAreaDto';
export class ReadStoreDeliveryDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadStoreDeliveryDto.prototype, "isEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 45, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStoreDeliveryDto.prototype, "time", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 3, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Max(1, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStoreDeliveryDto.prototype, "feeTaxPercentage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadStoreDeliveryDto.prototype, "haveCustomSchedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadStoreDeliveryDto.prototype, "isTipRequired", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 15, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStoreDeliveryDto.prototype, "minOrderTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 200, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStoreDeliveryDto.prototype, "maxOrderTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadAbstractStoreScheduleDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => ReadAbstractStoreScheduleDto),
    __metadata("design:type", ReadAbstractStoreScheduleDto)
], ReadStoreDeliveryDto.prototype, "weeklySchedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadAbstractStoreDelayedOrdersDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => ReadAbstractStoreDelayedOrdersDto),
    __metadata("design:type", ReadAbstractStoreDelayedOrdersDto)
], ReadStoreDeliveryDto.prototype, "delayedOrders", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadStoreDeliveryAreaDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => ReadStoreDeliveryAreaDto),
    __metadata("design:type", ReadStoreDeliveryAreaDto)
], ReadStoreDeliveryDto.prototype, "area", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'Delivery tip max amount in cents', example: 150, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Min(0, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStoreDeliveryDto.prototype, "tipMaxAmount", void 0);
//# sourceMappingURL=ReadStoreDeliveryDto.js.map